import { render, staticRenderFns } from "./recognition.config.vue?vue&type=template&id=0e5f8bf5"
import script from "./recognition.config.vue?vue&type=script&lang=js"
export * from "./recognition.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports